import React from "react";
import { observer } from "mobx-react";
import { EvaluationQueryViewStore } from "../../store";
import { EvaluationQueryViewForm } from "./EvaluationQueryViewForm";
import { ErrorDialog } from "../../../../common/controls";

export type EvaluationQueryViewProps = {
  evaluationQueryViewStore: EvaluationQueryViewStore;
};

export const EvaluationQueryView: React.FC<EvaluationQueryViewProps> = observer(
  ({ evaluationQueryViewStore }) => {
    return (
      <div>
        <EvaluationQueryViewForm
          query={evaluationQueryViewStore.queryValue}
          pathTypeOptions={evaluationQueryViewStore.getPathTypeOptions()}
          pathType={evaluationQueryViewStore.pathTypeValue}
          difficultyOptions={evaluationQueryViewStore.getDifficultyOptions()}
          difficulty={evaluationQueryViewStore.difficultyValue}
          expectedTool={evaluationQueryViewStore.expectedToolValue}
          expectedArgs={evaluationQueryViewStore.expectedArgsValue}
          acceptableTools={evaluationQueryViewStore.acceptableToolsValue}
          expectedResponsePattern={
            evaluationQueryViewStore.expectedResponsePatternValue
          }
          generatedFrom={evaluationQueryViewStore.generatedFromValue}
          isAmbiguous={evaluationQueryViewStore.isAmbiguousValue}
          ambiguityTypeOptions={evaluationQueryViewStore.getAmbiguityTypeOptions()}
          ambiguityType={evaluationQueryViewStore.ambiguityTypeValue}
          disambiguationResponse={
            evaluationQueryViewStore.disambiguationResponseValue
          }
          notes={evaluationQueryViewStore.notesValue}
          onPrint={(handlePrint: () => void) =>
            evaluationQueryViewStore.printEvaluationQuery(handlePrint)
          }
          onCancel={() => evaluationQueryViewStore.cancelEvaluationQuery()}
          onEdit={
            evaluationQueryViewStore.isEditEnabled
              ? () => evaluationQueryViewStore.editEvaluationQuery()
              : undefined
          }
        />
        <ErrorDialog
          open={evaluationQueryViewStore.errorDialogOpened}
          title={evaluationQueryViewStore.errorTitle}
          description={evaluationQueryViewStore.errorDescription}
          onClose={() => evaluationQueryViewStore.closeErrorDialog()}
        />
      </div>
    );
  }
);
